import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import api from '../modules/api'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    authenticated: !!window.localStorage.getItem(`${process.env.LOCALSTORAGE_PREFIX}access_token`),
    accessToken: window.localStorage.getItem(`${process.env.LOCALSTORAGE_PREFIX}access_token`),
    refreshToken: window.localStorage.getItem(`${process.env.LOCALSTORAGE_PREFIX}refresh_token`),
    expiresIn: window.localStorage.getItem(`${process.env.LOCALSTORAGE_PREFIX}expires_in`),
    adminId: window.localStorage.getItem(`${process.env.LOCALSTORAGE_PREFIX}admin_id`),
    isError: false,
    showErrorBubble: false,
    error: {},
    client: {},
    clients: [],
    clientsTotal: 0,
    permissions: [],
    permissionsTotal: 0,
    clientPermissions: [],
    clientPermissionsTotal: 0,
    devices: [],
    devicesTotal: 0,
    clientDevices: [],
    iosDevicesTotal: 0,
    androidDevicesTotal: 0,
    cameras: [],
    camerasTotal: 0,
    clientCameras: [],
    novatekCamerasTotal: 0,
    ambarellaCamerasTotal: 0,
    aitCamerasTotal: 0,
    otusCamerasTotal: 0,
    icatchCamerasTotal: 0,
    etronCamerasTotal: 0,
    clientDevicesTotal: 0,
    clientDevicesByPeriods: [],
    clientCamerasTotal: 0,
    clientCamerasByPeriods: [],
    article: {},
    clientArticles: [],
    clientArticlesTotal: 0,
    deleteArticle: {},
    file: {}
  },
  mutations,
  actions: actions(api)
})

// Set Authorization header on app launch (e.g. on page reload).
// Get token from the localStorage
store.dispatch('setToken', store.state.accessToken)

export default store



// WEBPACK FOOTER //
// ./src/store/index.js